<template>
  <div class="articlemain">
    <com-returntop></com-returntop>
    <div class="header-img">
      <img
        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/banner.png"
        alt
      />
    </div>
    <div class="toobar">
      <img
        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/active/active6.png"
        class="sactive-top-box-img"
        alt=""
        style="margin-left: 0px"
      />

      <img
        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/active/active5.png"
        alt=""
      />
      <span class="crumb" @click="goPage(1)">首页</span>
      <img
        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/active/active5.png"
        alt=""
      />
      <span class="crumb" @click="goPage(2)">{{ toTitle }}</span>
    </div>
    <div class="wenzi">
      <p>{{ title }}</p>
      <div class="time">
        <div>{{ currTime }}</div>
        <div class="laiyuan">
          <div><img src="../assets/laiyuan.png" alt="" width="20" /></div>
          <span>博努力</span>
        </div>
      </div>
      <div class="divider"></div>
      <div class="article-content" v-html="content"></div>
      <div v-if="attachment != ''" style="margin-bottom: 100px">
        附件下载：<a :href="attachment" download>{{ attachment_name }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import comReturntop from "@/components/returntop";
import { Article, timestampToTime } from "./../services/article";
import { mockArticles } from "./certificate/mockData";
export default {
  components: {
    comReturntop,
  },
  data() {
    return {
      titleList: [],
      content: "",
      title: "",
      id: 0, //文章id
      category_id: 0, //category_id
      attachment_name: "", //附件名称
      attachment: "", //附件地址
      toTitle: "",
      currTime: "",
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getList(this.$route.query.id, this.$route.query.top);
  },
  methods: {
    // 跳转方法
    goPage(val) {
      if (val == 1) {
        location.href = "https://www.bernouly.com/home";
      } else {
        if (this.toTitle == "公司动态") {
          location.href = "https://www.bernouly.com/active";
        } else if (
          this.toTitle == "国家政策文件" ||
          this.toTitle == "X证书实施方案"
        ) {
          location.href =
            "https://www.bernouly.com/certificatechildren";
        } else if (
          this.toTitle == "评价标准"
        ) {
          location.href = "https://www.bernouly.com/evalStandard";
        } else if (
          this.toTitle == "评价制度"
        ) {
          location.href = "https://www.bernouly.com/evalSystem";
        } else if (
          this.toTitle == "试点院校建设" ||
          this.toTitle == "会议通知"
        ) {
          location.href = "https://www.bernouly.com/evalStandard";
        }
      }
    },
    getList(id, top) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      if (mockArticles[id]) {
        const article = mockArticles[id];
        this.content = article.content;
        this.title = article.name;
        this.toTitle = article.category_name;
        this.currTime = article.release_time.substring(0, 10);
        return;
      }
      Article({
        id: id,
        top: top == null ? -1 : top,
      }).then((res) => {
        res.items.forEach((ele) => {
          if (ele.id == id) {
            this.content = ele.content;
            this.title = ele.name;
            this.toTitle = ele.category_name;
            this.currTime = ele.release_time.substring(0, 10);
            if (ele.attachment != null) {
              this.attachment_name = ele.attachment_name;
              this.attachment = ele.attachment;
            }
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.divider {
  width: 1150px;
  height: 1px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 50px;
  background: #e5e5e5;
}
.laiyuan {
  display: flex;
}
.time {
  height: 23px;
  line-height: 23px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 12px;
  color: #4a4a4a;
}
.time span {
  height: 23px !important;
}
.toobar img {
  margin-left: 20px;
}
.toobar span {
  margin-left: 20px;
  font-size: 14px;
  color: #929292;
  cursor: pointer;
}
.wenzi {
  margin: 0px auto;
  width: 1150px;
  padding: 20px 100px;
  padding-top: 50px;
  background-color: #ffffff;
  /* box-shadow: 0 0 2px #031a3c; */
}
.wenzi p {
  width: 800px;
  height: 30px;
  margin: 0 auto;
  line-height: 30px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 66px;
}
.articlemain {
  background: #eeeeee;
  padding-bottom: 65px;
}

.articlemain img {
  display: inline-block;
}

.articlemain .header-img {
  width: 100%;
  height: 237px;
}

.articlemain .header-img img {
  width: 100%;
  height: 100%;
}

.articlemain .middle {
  width: 100%;
  /* height: 680px; */
}

.articlemain .toobar {
  width: 1350px;
  height: 40px;
  line-height: 40px;
  margin: 40px auto;
}

.articlemain .middle img:hover {
  cursor: pointer;
}

.articlemain li {
  width: 100px;
  height: 80px;
  color: #fefefe;
  line-height: 80px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  display: list-item;
}

.articlemain li:hover {
  background: #0a57f4;
}

.article-content {
  font-size: 16px !important;
  margin-bottom: 100px;
  text-indent: 2em;
  color: #4f4f4f;
  margin-bottom: 65px;
}


.article-content img:last-of-type() {
  width: 16px !important;
  height: 16px !important;
}

.article-content p > img {
  width: 1000px;
}
</style>
